import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const roleService = {
  // Roles
  listRoles: async () => (await api.get('/roles')).data,
  getRole: async (id) => (await api.get(`/roles/${id}`)).data,
  createRole: async (data) => (await api.post('/roles', data)).data,
  updateRole: async (id, data) => (await api.put(`/roles/${id}`, data)).data,
  deleteRole: async (id) => (await api.delete(`/roles/${id}`)).data,

  // Permissions
  listPermissions: async () => (await api.get('/permissions')).data,
  grantPermissionToRole: async (roleId, permissionId) =>
    (await api.post(`/roles/${roleId}/permissions`, { permissionId })).data,
  revokePermissionFromRole: async (roleId, permissionId) =>
    (await api.delete(`/roles/${roleId}/permissions/${permissionId}`)).data,
};

export default roleService;



